import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d0223f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "feeds"
}
const _hoisted_2 = { class: "feeds__columns" }
const _hoisted_3 = { class: "feed-card__cover" }
const _hoisted_4 = {
  key: 1,
  class: "feed-card__summary"
}
const _hoisted_5 = { class: "feed-card__meta" }
const _hoisted_6 = { class: "feed-card__creator" }
const _hoisted_7 = {
  key: 0,
  class: "feed-card__avatar"
}
const _hoisted_8 = { class: "feed-card__name" }
const _hoisted_9 = {
  key: 0,
  class: "feed-card__like"
}

import { computed } from "vue";
import { DuIcon } from "dangoui";
import { Image as VanImage } from "vant";
import { buildHotspotFeedCards } from "../model";
import type { HotspotFeed, HotspotFeedCard } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'Feeds',
  props: {
    feeds: null
  },
  emits: ["open-app"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-app"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  feeds: HotspotFeed[];
}





const cards = computed<HotspotFeedCard[]>(() =>
  buildHotspotFeedCards(props.feeds || [])
);

const creatorName = (item: HotspotFeedCard) => {
  return (
    item.creator?.displayName ||
    item.creator?.nickName ||
    item.creator?.nickname ||
    "-"
  );
};

return (_ctx: any,_cache: any) => {
  return (_unref(cards).length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (item) => {
            return (_openBlock(), _createElementBlock("article", {
              key: item.id,
              class: "feed-card",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-app')))
            }, [
              (item.cover)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "feed-card__cover-wrap",
                    style: _normalizeStyle({ paddingBottom: `${100 / item.ratio}%` })
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(VanImage), {
                        fit: "cover",
                        class: "feed-card__cover-image",
                        src: item.cover,
                        alt: item.summary || ''
                      }, null, 8, ["src", "alt"])
                    ])
                  ], 4))
                : _createCommentVNode("", true),
              (item.summary)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.summary), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (item.creator?.avatar || item.creator?.avatarUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(VanImage), {
                          fit: "cover",
                          class: "feed-card__avatar-image",
                          src: item.creator?.avatar || item.creator?.avatarUrl,
                          alt: creatorName(item)
                        }, null, 8, ["src", "alt"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(creatorName(item)), 1)
                ]),
                (item.likeCount != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_unref(DuIcon), {
                        name: "community-like-normal",
                        size: "3.733333333333334rem",
                        color: "#000000a3"
                      }),
                      _createElementVNode("span", null, _toDisplayString(item.likeCount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})